var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.banner.length>0)?_c('div',{staticClass:"tip-top"},[_c('mt-swipe',{attrs:{"show-indicators":true}},_vm._l((_vm.banner),function(item){return _c('mt-swipe-item',{key:item.id},[_c('img',{attrs:{"src":item.pic,"alt":""},on:{"click":function($event){return _vm.handleClick(item.value,item.id)}}})])}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }